export const integrationStatus = {
  authorizationExpiresTitle: "Authorization expires soon",
  authorizationExpiresText:
    "Consider reauthorizing soon to prevent service interruption.",
  actionRequiredTitle: "Action required",
  actionRequiredText: "Please reauthorize to prevent service interruption.",
  takeAction: "Take action",
  dialogTitle: "Integration Status",
  statusLabel: "Status:",
  actionRequiredLabel: "Action Required:",
  close: "Close",
  reauthorize: "Reauthorize",
  viewSettings: "View Settings"
};
